import Store from 'store/store'
import { Component } from 'utils/jsx'
import microdefer from 'utils/microdefer'
import contrast from 'utils/color-contrast'

import Swatch from 'components/dom/Swatch'

import render from 'ffp-generate/render'
import Seed from 'controllers/landscape/seed'

export default class Landscape extends Component {
  beforeRender () {
    this.handleClick = this.handleClick.bind(this)
    this.update = microdefer(this.update, this)
  }

  template () {
    return (
      <div class='landscape' store-class-is-loading={Store.landscape.isLoading}>
        <div class='landscape__container' event-click={this.handleClick}>
          <canvas data-color-space='rgb' ref={this.ref('canvasRGB')} />
          <canvas data-color-space='cmyk' ref={this.ref('canvasCMYK')} />
        </div>
        <Swatch />
      </div>
    )
  }

  afterRender () {
    Store.landscape.abstraction.subscribe(this.update)
    this.update()
  }

  update () {
    const landscape = Store.landscape.abstraction.get()
    if (!landscape) return

    // This is used to display text on canvas
    this.base.style.setProperty(
      '--color',
      contrast(landscape.props.background.rgb)
    )

    render.canvas(landscape, this.refs.canvasRGB, { colorSpace: 'css' })
    this.refs.canvasRGB.style.width = ''
    this.refs.canvasRGB.style.height = ''

    render.canvas(landscape, this.refs.canvasCMYK, { colorSpace: 'css-cmyk-proof' })
    this.refs.canvasCMYK.style.width = ''
    this.refs.canvasCMYK.style.height = ''

    Store.landscape.image.set({
      rgb: this.refs.canvasRGB.toDataURL(),
      cmyk: this.refs.canvasCMYK.toDataURL()
    })
  }

  handleClick (e) {
    Seed.incrementAbstraction()
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Landscape.js